import { AspectRatio } from 'react-aspect-ratio';
import styled from 'styled-components';

export const JoinPanelButtons = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    @media screen and (max-width: 800px) {
        justify-content: center;
    }

    @media screen and (max-width: 500px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }

    @media screen and (min-width: 801px) and (max-height: 748px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

export const AspectRatioStyled = styled(AspectRatio)`
    height: 100%;
`;
